const config = {
    build_number: '615688',
    build_timestamp: '2026-08-31T15:23:51.957Z',
    build_commit: '0c0bf449ff266df3a0f4253c250321ae7fd30e40',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
